export const initialState = () => {
  return {
    currentUser: {
      isAuthenticated: false
    },

    notification: {
      message: '',
      status: 'info'
    },

    login: {
      form: {
        fields: {
          email: {
            label: 'E-mailadres',
            name: 'email',
            value: '',
            error: '',
            rule: 'required|email',
            required: true,
            tooltip: ''
          },
          password: {
            label: 'Wachtwoord',
            name: 'password',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            type: 'password',
            tooltip: ''
          }
        },

        error: '',
        isValid: false,
        notification: {
          message: '',
          status: 'info'
        }
      }
    },

    // object with "name of object to delete" as key and an array of ids (.e.g. { row: [1, 3, 5], number: [22, 47] })
    idsToDelete: {
      // row: [],
      // number: [],
      // legend: []
    },

    textForm: {
      form: {
        fields: {
          title: {
            label: '',
            placeholder: 'Titel / waarde',
            name: 'title',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            tooltip: ''
          },
          button_text: {
            label: '',
            placeholder: 'Button label',
            name: 'button_text',
            value: '',
            error: '',
            rule: '',
            required: false,
            tooltip: ''
          },
          body: {
            label: '',
            placeholder: 'Inhoud',
            name: 'body',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            tooltip: ''
          },
          realm: {
            label: '',
            placeholder: 'Intern ID',
            name: 'realm',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            tooltip: ''
          }
        },

        error: '',
        isValid: false,
        notification: {
          message: '',
          status: 'info'
        }
      }
    },

    puzzleForm: {
      form: {
        fields: {
          published: {
            label: 'Publiceren?',
            name: 'published',
            value: '',
            error: '',
            rule: '',
            required: false,
            tooltip: ''
          },
          start_date: {
            label: 'Start datum',
            name: 'start_date',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            tooltip: ''
          },
          start_hour: {
            label: 'Start uur',
            name: 'start_hour',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            tooltip: ''
          }
        },

        error: '',
        isValid: false,
        notification: {
          message: '',
          status: 'info'
        }
      }
    },

    puzzleWordsForm: {
      form: {
        fields: {
        },

        templateFields: [
          {
            label: 'Woord',
            placeholder: 'Woord',
            name: 'word',
            value: '',
            error: '',
            rule: ['required'],
            required: true,
            tooltip: ''
          },
          {
            label: 'Tip',
            placeholder: 'Tip',
            name: 'tip',
            value: '',
            error: '',
            rule: 'required',
            required: true,
            tooltip: ''
          },
          {
            label: 'Artikel URL',
            placeholder: 'Artikel URL',
            name: 'href',
            value: '',
            error: '',
            rule: ['required', 'url'],
            required: true,
            tooltip: ''
          },
          {
            label: 'Opengraph data',
            placeholder: 'Opengraph data',
            name: 'opengraph_data',
            value: '',
            error: '',
            rule: [],
            required: false,
            tooltip: ''
          },
          {
            label: 'Is bonus?',
            placeholder: 'Is bonus?',
            name: 'is_bonus',
            value: '',
            error: '',
            rule: '',
            required: false,
            tooltip: ''
          }
        ],

        error: '',
        isValid: false,
        notification: {
          message: '',
          status: 'info'
        }
      }
    },

    // Used in public flow
    solutionForm: {
      form: {
        fields: {
          solution: {
            label: '',
            placeholder: 'Oplossing',
            name: 'solution',
            value: '',
            error: '',
            rule: ['required'],
            required: false,
            tooltip: ''
          }
        },

        error: '',
        isValid: false,
        notification: {
          message: '',
          status: 'info'
        }
      }
    }
  }
}
